<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Compliance Limit</div>
        <div>
          <bread-crumb :bread-crumbs="['Compliance Limit']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 mt-1 primary--text"></v-divider>
      <v-card-text>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="allLimits"
          sort-by="calories"
          :search="search"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-dialog persistent v-model="dialog" max-width="700px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn depressed 
                    :disabled="isLimitReached"
                    color="primary"
                    dark
                    small
                    class="me-3 text-capitalize"
                    v-bind="attrs"
                    v-on="on"
                    @click="isUpdate = false"
                  >
                  <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon>Add
                  </v-btn>

                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Type here to filter the table data."
                      single-line
                      hide-details
                      dense
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-spacer></v-spacer>
                  <v-spacer></v-spacer>
                  <v-btn depressed  @click="downloadExcelsheet" color="primary" small
                  ><v-icon small>mdi-file-excel-outline</v-icon>Export
                </v-btn>
                </template>
                <v-card flat>
                  <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
                    <span class="subtitleFontsize">{{ formTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed  small icon @click="close">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-form ref="complincelimts" v-model="valid" lazy-validation>
                    <v-card-text class="mt-5">
                      <v-row>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 required labelFontsize">
                            User type
                          </label>
                          <v-autocomplete
                            class="rounded"
                            v-model="compliancelimits.user_type"
                            dense
                            outlined
                            placeholder="User type"
                            :items="user_Type"
                            item-value="value_code"
                            item-text="value"
                            :rules="type"
                            :disabled="isUpdate"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 required labelFontsize"
                            >User Category</label
                          >
                          <v-autocomplete
                            class="rounded"
                            dense
                            outlined
                            placeholder="User Category"
                            :items="User_Category"
                            item-value="value_code"
                            item-text="value"
                            v-model="compliancelimits.user_category"
                            :rules="catogry"
                            :disabled="isUpdate"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 required labelFontsize">
                            Onboard Type
                          </label>
                          <v-autocomplete
                            class="rounded"
                            dense
                            outlined
                            placeholder="Onboard Type"
                            :items="Onboard_Type"
                            item-value="value_code"
                            item-text="value"
                            v-model="compliancelimits.onboard_type"
                            :rules="Onboard"
                            :disabled="isUpdate"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <label class="my-0 required labelFontsize">
                            Remit Type
                          </label>
                          <v-autocomplete
                            class="rounded"
                            dense
                            outlined
                            placeholder="Remit Type"
                            :items="remit_Type"
                            item-value="value_code"
                            item-text="value"
                            v-model="compliancelimits.remit_type"
                            :rules="Remit"
                            :disabled="isUpdate"
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 required labelFontsize"
                            >Daily limit</label
                          >
                          <v-text-field
                            class="rounded"
                            dense
                            outlined
                            type="number"
                            hide-spin-buttons
                            placeholder="Daily limit"
                            v-model="compliancelimits.daily_limit"
                            :rules="dailylimitrules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6"
                          ><label class="my-0 required labelFontsize">
                            Monthly limit
                          </label>
                          <v-text-field
                            class="rounded"
                            dense
                            outlined
                            type="number"
                            hide-spin-buttons
                            placeholder="Monthly limit"
                            v-model="compliancelimits.monthly_limit"
                            :rules="monthlilimitrules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <!-- <label class="my-0 labelFontsize"> Status </label>
                          <v-autocomplete
                            class="rounded"
                            dense
                            outlined
                            placeholder="Status"
                            :items="Stauats"
                            v-model="compliancelimits.is_enable"
                            :rules="userstats"
                          ></v-autocomplete> -->
                          <v-switch
                            label="Active"
                            class="ma-0 pa-0 add-check"
                            hide-details
                            v-model="compliancelimits.is_enable"
                          >
                          </v-switch>
                        </v-col>
                      </v-row> </v-card-text
                  ></v-form>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn depressed 
                      small
                      color="primary"
                      class="text-capitalize"
                      @click="isUpdate ? updateLimitByid() : postList()"
                    >
                      {{ isUpdate ? "Update" : "Save" }}
                    </v-btn>
                    <v-btn depressed 
                      small
                      color="primary"
                      class="text-capitalize ms-2"
                      @click="close"
                      outlined
                    >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.is_enable="{ item }">
            <v-switch
              v-model="item.is_enable"
              height="0px"
              color="primary"
              dense
              @change="UpdatelimitStatus(item.limit_id, item.is_enable)"
            ></v-switch>
          </template>
          <template v-slot:item.actions="{ item }">
            <div>
              <v-icon
                small
                class="mr-2"
                color="primary"
                @click="editItem(item)"
              >
                mdi-content-save-edit-outline
              </v-icon>
            </div>
          </template>
        </v-data-table>
        <OverlayPageVue :showOverlay="loaderOverlay" />
      </v-card-text>
    </v-card>
    <ComplainceTransLimit />
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import ComplainceTransLimit from "./complianceTrans/ComplainceTransLimit.vue";
import alerts from "@/mixins/alerts";
import { compliancelimits } from "@/utils/validationCopy.js";
import setupService from "@/services/SetupService/setupService.js";
import commonService from "@/services/CommonService/commonService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
export default {
  name: "Compliance Limit",
  mixins: [alerts],
  data: () => ({
    ...compliancelimits,
    dialog: false,
    loaderOverlay: false,
    search: "",
    valid: true,
    isUpdate: true,
    editedIndex: -1,
    allLimits: [],
    limitid: "",
    remit_Type: [],
    Onboard_Type: [],
    User_Category: [],
    user_Type: [],
    Stauats: [
      { text: "Active", value: "true" },
      { text: "In-Active", value: "false" },
    ],
    headers: [
      {
        text: "SNo",
        align: "start",
        sortable: false,
        value: "limit_id",
      },
      { text: "User Type", value: "user_type" },
      { text: "User Category", value: "user_category" },
      { text: "Onboard Type", value: "onboard_type" },
      { text: "Remit Type", value: "remit_type" },
      { text: "Daily Limit", value: "daily_limit" },
      { text: "Monthly Limit", value: "monthly_limit" },
      { text: "Active", value: "is_enable", sortable: false },
      { text: "Action", value: "actions", sortable: false },
    ],
    compliancelimits: {
      user_type: "",
      user_category: "",
      onboard_type: "",
      remit_type: "",
      daily_limit: 0,
      monthly_limit: 0,
      is_enable: false,
    },
    is_enable: false,
    isLimitReached: false,
    limit_id: null,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  components: {
    BreadCrumb,
    ComplainceTransLimit,

    OverlayPageVue,
  },
  validations() {
    return {};
  },
  watch: {
    dialog(val) {
      if (val) {
        this.remit_Type = [];
        this.User_Category = [];
      }
      val || this.close();
    },
    "compliancelimits.user_type"(val) {
      this.getDropdownByUsertype(val, "RMT");
      this.getDropdownByUsertype(val, "usc");
    },
  },

  mounted() {
    this.getallcompliancelimits();
    this.getParametersByCode("UTP");
    // this.getParametersByCode("RMT");
    this.getParametersByCode("OBT");
    // this.getParametersByCode("usc");

    this.hideButton();
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.allLimits) {
        this.exportToExcel(this.headers, this.allLimits, "Compilence limits");
      }
    },
    async hideButton() {
      this.loaderOverlay = true;
      try {
        const response = await setupService.hideButton();
        if (response.data.status_code === 200) {
          this.isLimitReached = response.data.data[0].is_limit_reached;
          console.log("this.isLimitReached", this.isLimitReached);
          this.stoploader();
        } 
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.hideButton();
        //   this.stoploader();
        // }
         else {
          this.stoploader();
        }
      } catch (error) {
        this.stoploader();
        console.error(error);
      }
    },
    close() {
      this.dialog = false;
      this.isUpdate = false;
      this.compliancelimits = {
        user_type: "",
        user_category: "",
        onboard_type: "",
        remit_type: "",
        daily_limit: 0,
        monthly_limit: 0,
        is_enable: false,
      };
      this.$refs.complincelimts.reset();
    },
    editItem(item) {
      console.log("item", item);
      // Reset the form validation
      if (this.$refs.complincelimts) {
        this.$refs.complincelimts.resetValidation();
      }
      this.dialog = true;
      this.isUpdate = true;
      this.limit_id = item.limit_id;
      this.getcompliancelimitbyid(item);
      // this.compliancelimits = {
      //   user_type: "",
      //   user_category: "",
      //   onboard_type: "",
      //   remit_type: "",
      //   daily_limit: 0,
      //   monthly_limit: 0,
      //   is_enable: false,
      // };
    },
    async getDropdownByUsertype(type, code) {
      // this.loaderOverlay = true;
      try {
        const response = await commonService.getDropdownByUsertype(type, code);
        if (response.data.status_code === 200) {
          switch (code) {
            case "RMT":
              console.log("RMT codes", response.data);
              this.remit_Type = response.data.data.map((ele) => {
                return {
                  value: ele.value,
                  value_code: ele.value_code,
                };
              });
              break;
            case "usc":
              console.log("use codes", response.data);
              this.User_Category = response.data.data.map((ele) => {
                return {
                  value: ele.value,
                  value_code: ele.value_code,
                };
              });
              break;
          }
        } 
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getDropdownByUsertype(code);
        // }
        console.log("paymentmode", response);
      } catch (error) {
        console.error(error);
      }
    },
    async getParametersByCode(code) {
      // this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);

        if (response.data.status_code === 200) {
          switch (code) {
            case "UTP":
              console.log("UTP codes", response.data);
              this.user_Type = response.data.data.map((ele) => {
                return {
                  value: ele.value,
                  value_code: ele.value_code,
                };
              });
              break;
            case "OBT":
              console.log("OBT codes", response.data);
              this.Onboard_Type = response.data.data.map((ele) => {
                return {
                  value: ele.value,
                  value_code: ele.value_code,
                };
              });
              break;
          }
        } 
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getParametersByCode(code);
        // }
      } catch (error) {
        console.error(error);
      }
    },
    async postList() {
      const validate = this.$refs.complincelimts.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await setupService.PostLimit(
            this.compliancelimits
          );
          if (responseData && responseData.data.status_code == 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
            this.close();
            this.getallcompliancelimits();
            this.hideButton();
          } 
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.postList();
          // } 
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async updateLimitByid() {
      const validate = this.$refs.complincelimts.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await setupService.updateLimit(
            this.limit_id,
            this.compliancelimits
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.close();
            this.getallcompliancelimits();
          }
          //  else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.updateLimitByid();
          // } 
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async UpdatelimitStatus(limit_id, limit_status) {
      this.loaderOverlay = true;
      try {
        const responseData = await setupService.updateLimitstatus(
          limit_id,
          limit_status
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getallcompliancelimits();
        } 
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.UpdatelimitStatus(limit_id, limit_status);
        // } 
        else {
          this.showAlertError(responseData.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    async getallcompliancelimits() {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getallLimits();
        if (response.data.status_code === 200) {
          this.allLimits = response.data.data;
          this.stoploader();
        } 
        else if (response.data.status_code === 401) {
          this.allLimits = [];
          // this.returnNewToken();
          // this.getallcompliancelimits();
          // this.stoploader();
        }
         else {
          this.allLimits == [];
          this.stoploader();
        }
      } catch (error) {
        this.allLimits = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getcompliancelimitbyid(item) {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getLimitbyId(item.limit_id);
        if (response.data.status_code === 200) {
          this.compliancelimits = {
            user_type: response.data.data[0].user_type.toUpperCase(),
            user_category: response.data.data[0].user_category,
            onboard_type: response.data.data[0].onboard_type,
            remit_type: response.data.data[0].remit_type,
            daily_limit: response.data.data[0].daily_limit,
            monthly_limit: response.data.data[0].monthly_limit,
            is_enable: response.data.data[0].is_enable,
          };
          this.stoploader();
        }
        //  else if (response.data.status_code === 401) {
        //   this.compliancelimits = [];
        //   this.returnNewToken();
        //   this.getcompliancelimitbyid();
        //   this.stoploader();
        // } 
        else {
          this.compliancelimits == [];
          this.stoploader();
        }
      } catch (error) {
        this.compliancelimits = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
